import { render, staticRenderFns } from "./index__.vue?vue&type=template&id=6d0eb1c6&scoped=true"
import script from "./index__.vue?vue&type=script&lang=js"
export * from "./index__.vue?vue&type=script&lang=js"
import style0 from "./index__.vue?vue&type=style&index=0&id=6d0eb1c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0eb1c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0eb1c6')) {
      api.createRecord('6d0eb1c6', component.options)
    } else {
      api.reload('6d0eb1c6', component.options)
    }
    module.hot.accept("./index__.vue?vue&type=template&id=6d0eb1c6&scoped=true", function () {
      api.rerender('6d0eb1c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/publishProduct/index__.vue"
export default component.exports